var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "url(#paint0_linear_4756_21359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5999 59.4298C34.7356 59.2887 34.8988 59.1769 35.0794 59.1012C35.2599 59.0256 35.4541 58.9877 35.6499 58.9898H72.1499C72.2515 58.9949 72.3511 59.0201 72.4429 59.0639C72.5347 59.1078 72.6169 59.1693 72.6848 59.2451C72.7527 59.3209 72.8049 59.4094 72.8383 59.5055C72.8718 59.6015 72.8859 59.7033 72.8799 59.8048C72.8716 59.9902 72.7991 60.167 72.6749 60.3048L65.4649 67.4998C65.1863 67.7788 64.8091 67.9368 64.4149 67.9398H27.9149C27.7558 67.9528 27.5967 67.9143 27.4611 67.83C27.3255 67.7457 27.2206 67.6201 27.1618 67.4717C27.103 67.3233 27.0934 67.1599 27.1344 67.0056C27.1755 66.8514 27.2651 66.7144 27.3899 66.6148L34.5999 59.4298Z",
    fill: "url(#paint1_linear_4756_21359)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5997 32.5002C34.8775 32.2194 35.2548 32.0595 35.6497 32.0552H72.1497C72.2965 32.0572 72.4395 32.1023 72.5609 32.1849C72.6823 32.2674 72.7768 32.3838 72.8327 32.5195C72.8886 32.6553 72.9034 32.8045 72.8753 32.9486C72.8472 33.0927 72.7775 33.2253 72.6747 33.3302L65.4647 40.5702C65.1861 40.8491 64.8089 41.0072 64.4147 41.0102H27.9147C27.7099 40.9986 27.5181 40.9063 27.3813 40.7535C27.2445 40.6007 27.1738 40.4 27.1847 40.1952C27.193 40.0098 27.2654 39.833 27.3897 39.6952L34.5997 32.5002Z",
    fill: "url(#paint2_linear_4756_21359)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4647 45.8801C65.3285 45.7392 65.1653 45.6273 64.9849 45.5508C64.8046 45.4743 64.6106 45.435 64.4147 45.4351H27.9147C27.7099 45.4467 27.5181 45.539 27.3813 45.6917C27.2445 45.8445 27.1738 46.0453 27.1847 46.2501C27.1921 46.4356 27.2647 46.6127 27.3897 46.7501L34.5997 53.9251C34.7359 54.0659 34.8991 54.1779 35.0794 54.2543C35.2598 54.3308 35.4538 54.3701 35.6497 54.3701H72.1497C72.2965 54.368 72.4395 54.3229 72.5609 54.2404C72.6823 54.1578 72.7768 54.0414 72.8327 53.9057C72.8886 53.7699 72.9034 53.6208 72.8753 53.4767C72.8472 53.3326 72.7775 53.1999 72.6747 53.0951L65.4647 45.8801Z",
    fill: "url(#paint3_linear_4756_21359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4756_21359",
    x1: 50,
    y1: 100,
    x2: 50,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4756_21359",
    x1: 68.6499,
    y1: 27.7498,
    x2: 43.3749,
    y2: 76.1498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4756_21359",
    x1: 57.6197,
    y1: 21.9852,
    x2: 32.3697,
    y2: 70.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4756_21359",
    x1: 63.1197,
    y1: 24.8601,
    x2: 37.8397,
    y2: 73.2601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.43d0596f97941116fd2aa003aec50a45.svg";
export { ForwardRef as ReactComponent };